import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';
import articulo from './articulo';

const state = {
    id: 0,
    observaciones: '',
    rowVersion: null,

    renglones: [],

    /* Vista de datos */
    controlStockDatos: [],
    renglonesDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_CONTROL_STOCK' (state, controlStockId) {
        state.id = controlStockId;
        state.observaciones = '';
        state.rowVersion = null;

        state.renglones= [];
    },
    'SET_CONTROL_STOCK' (state, controlStock) {
        state.observaciones = controlStock.observaciones.trim();
        state.rowVersion = controlStock.rowVersion;
        
        // state.renglones= controlStock.renglones;
        state.renglones= controlStock.renglones.map(renglon => ({ 
            ...renglon,
            articulo: renglon.articulo.nombre 
        }));
    },
    'SET_ARTICULOS' (state, articulos) {
        articulos.forEach(articulo => {
            state.renglones.push({
                articuloId: articulo.id,
                articulo: articulo.nombre,
                cantidadStock: articulo.stock,
                cantidadControl: articulo.stock,
                cantidadAjustada: false
            })    
        });

        state.renglones.sort(function(a, b){
            let x = a.articulo.toLowerCase().trim();
            let y = b.articulo.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });
    },


    'INICIALIZAR_DATOS' (state) {
        state.controlStockDatos = [];
        state.renglonesDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.controlStockDatos = params.controlStockDatos;
        state.renglonesDatos = params.renglonesDatos;
        // state.renglonesDatos = params.renglonesDatos.map(renglon => ({ ...renglon, moneda: params.certificadoDatosRpt.moneda.trim() }));
    },
};

function roundToTwo(num) {    
    return +(Math.round(num + "e+2")  + "e-2");
}

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, controlStockId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CONTROL_STOCK', controlStockId);

            if (controlStockId != 0) {
                apiAxios.get('controles-stock/' + controlStockId + '/abm' ) 
                    .then(res => {
                        commit('SET_CONTROL_STOCK', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                apiAxios.get('articulos/stock/list' ) 
                    .then(res => {
                        commit('SET_ARTICULOS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

                // resolve();
            }
        })            
    },
    save ( { state }, finalizar ) {
        return new Promise((resolve, reject) => {
            let isValid = true;
            let errorMessage = '';
            
            // if (state.renglones.length == 0) {
            //     isValid = false;
            //     errorMessage = 'No se puede registrar un control de stock sin artículos.';
            // }

            if (isValid) {
                let renglones = state.renglones.map(renglon => ({
                    articuloId: renglon.articuloId,
                    cantidadStock: renglon.cantidadStock,
                    cantidadControl: renglon.cantidadControl,
                    cantidadAjustada: renglon.cantidadStock != renglon.cantidadControl & finalizar
                }))
            
                let controlStock= {
                    observaciones: state.observaciones.trim(),
                    renglones: renglones,
                    finalizar
                };

                let url = 'controles-stock';

                if (state.id != 0) {
                    controlStock.rowVersion = state.rowVersion;
                    url += '/' + state.id;
                } 
    
                apiAxios.post(url, controlStock)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
                } else {
                    reject(errorMessage);
                }
            })
    },

    getDatos ( { commit }, controlStockId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (controlStockId) {
                apiAxios.get('controles-stock/' + controlStockId ) 
                    .then(res => {
                        let renglonesDatos = res.data.renglones;
                        
                        let params = {
                            controlStockDatos: res.data,
                            renglonesDatos,
                        }
                        
                        commit('SET_DATOS', params);
                        resolve();
                    })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}